import ApiClient from './apiClient';

export const fetchOrderHistory = async (
  module: string,
  lang: string,
  juicyAppUniqueId: string,
) => {
  const response = await ApiClient.getInstance().post({
    url: `${module}/getorderhistory`,
    data: {
      juicyAppUniqueId: juicyAppUniqueId,
      lang: lang
    },
  });
  return response.data;
};

export const fetchOrderDetails = async (module: string, params: object) => {
  // console.log('params', params);
  const response = await ApiClient.getInstance().post({
    url: `${module}/getorderdetails`,
    axiosConfig: { params: params },
  });
  return response.data;
};

export const fetchOrderStatusHistory = async (module: string, dto: object) => {
  const response = await ApiClient.getInstance().post({
    url: `${module}/orderstatushistory`,
    data: dto,
  });
  return response.data;
};
